import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px 40px',
      backgroundColor: '#2c3e50',
      color: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
        HRMS Lite
      </div>
      <div style={{ display: 'flex', gap: '20px' }}>
        <Link to="/employees" style={{
          color: 'white',
          textDecoration: 'none',
          padding: '10px 15px',
          borderRadius: '5px',
          transition: 'background-color 0.3s'
        }} onMouseOver={(e) => e.target.style.backgroundColor = '#34495e'} onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}>
          EmployeeList
        </Link>
        <Link to="/attendance" style={{
          color: 'white',
          textDecoration: 'none',
          padding: '10px 15px',
          borderRadius: '5px',
          transition: 'background-color 0.3s'
        }} onMouseOver={(e) => e.target.style.backgroundColor = '#34495e'} onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}>
          AttendanceList
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
